import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider } from "react-router-dom";
import { routes } from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {

  return (
    <div className="App">
       <QueryClientProvider client={queryClient}>
        <RouterProvider router={routes} />
        </QueryClientProvider>
    </div>
  );
}

export default App;
